import type { Id } from '../../convex/_generated/dataModel';

/** VUM package option fields that scope eligible stays */
export type VumAccommodationScope = {
  forAllAccommodations?: boolean;
  accommodationTypes?: string[];
  specificAccommodationIds?: Id<'accommodations'>[];
  /** @deprecated prefer specificAccommodationIds */
  specificAccommodationId?: Id<'accommodations'>;
};

export function resolveSpecificAccommodationIds(opt: VumAccommodationScope): Id<'accommodations'>[] {
  const fromArr = opt.specificAccommodationIds?.filter(Boolean) ?? [];
  if (fromArr.length > 0) return fromArr;
  if (opt.specificAccommodationId) return [opt.specificAccommodationId];
  return [];
}
